module.exports = __webpack_public_path__ + "static/media/banner_bg_tutorials_mobile.fc17f715.png";